<template>
    <AppLayout
        page="/dashboard"
        pageTitle="Drop-ins"
        backLink="/dashboard/reports"
    >
        <v-overlay :value="retryLoading" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-col cols="12" class="pa-1">
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="soli-subtitle"
                                    >{{
                                        `${globalMomentMonthFull()} ${globalMomentYear()}`
                                    }}
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    style="white-space: normal"
                                    >Scheduled assessment lessons
                                </v-list-item-subtitle>
                                <v-list-item-subtitle
                                    class="font-bold"
                                    style="white-space: normal"
                                >
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-row>
                                    <v-menu
                                        right
                                        :close-on-content-click="false"
                                        v-if="$vuetify.breakpoint.xs"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                :small="$vuetify.breakpoint.xs"
                                                icon
                                                class="elevation-3 ml-1"
                                            >
                                                <v-badge
                                                    color="accent"
                                                    overlap
                                                    bordered
                                                    dot
                                                    :value="search"
                                                >
                                                    <v-icon
                                                        class="soli-blue-text text-shadow-blue"
                                                        >filter_list</v-icon
                                                    >
                                                </v-badge></v-btn
                                            >
                                        </template>
                                        <v-list
                                            ><v-list-item class="pl-0">
                                                <v-text-field
                                                    v-model="search"
                                                    class="pl-6 white pt-0 mt-0"
                                                    label="Filter"
                                                    single-line
                                                    clearable
                                                    :append-icon="
                                                        search
                                                            ? null
                                                            : 'filter_list'
                                                    "
                                                    hide-details
                                                ></v-text-field></v-list-item></v-list
                                    ></v-menu>
                                </v-row>
                            </v-list-item-action>
                            <v-list-item-action
                                v-if="$vuetify.breakpoint.smAndUp"
                            >
                                <v-text-field
                                    v-model="search"
                                    style="width: 200px"
                                    class="pl-6"
                                    append-icon="filter_list"
                                    label="Filter"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-list-item-action> </v-list-item
                    ></v-list>
                    <v-data-table
                        :headers="headers"
                        :items="dropIns"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :search="search"
                    >
                        <template v-slot:[`item.recipient`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <v-list-item-avatar
                                    style="float: left"
                                    class="my-0"
                                >
                                    <v-img
                                        :src="item.recipient.profile_photo_url"
                                    ></v-img>
                                </v-list-item-avatar>
                                <div>
                                    <v-list-item-title>
                                        <Link
                                            :href="`/profile/${item.recipient.id}/account`"
                                        >
                                            {{ item.recipient.name }}
                                        </Link>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.recipient.email }}
                                    </v-list-item-subtitle>
                                </div>
                            </div>
                        </template>

                        <template v-slot:[`item.passes`]="{ item }">
                            <div class="font-bold soli-grey">
                                {{ item.passes }}
                            </div>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import globalMoment from "../../Mixins/GlobalMoment";

export default {
    props: ["dropIns"],
    mixins: [globalMoment],
    components: {
        AppLayout,
        Link,
    },
    data() {
        return {
            search: "",
            retryLoading: false,
            showMessage: false,
            headers: [
                {
                    text: "Student",
                    align: "start",
                    sortable: true,
                    value: "recipient",
                },
                {
                    text: "Remaining",
                    align: "start",
                    sortable: true,
                    value: "passes",
                },
            ],
        };
    },
};
</script>
